/**
 * Calculates a vh/wv value to a pixel value.
 *
 * @param {string} value The value of vh/wv to calculate for, should be in the css format.
 * @returns {number}
 */
function viewportToPixels(value) {
  const parts = value.match(/([0-9\.]+)(vh|vw)/);
  const q = Number(parts[1]);
  const side =
    window[["innerHeight", "innerWidth"][["vh", "vw"].indexOf(parts[2])]];
  return side * (q / 100);
}

/**
 *
 * Handles calculations for the default split header size so that it looks
 * good on mobile devices and shows the content for the headers where it makes sense.
 *
 */
function calculateHeaderHeight() {
  const headerContent = document.querySelector(".calculate-header-height");
  const defaultHeaderHeight = document.querySelector(".header-height-default");
  const isKomitea = !!document.querySelector(".komitea-template-default");
  if (!headerContent || !defaultHeaderHeight) return;
  if (window.matchMedia("(min-width: 768px)").matches) {
    defaultHeaderHeight.style.height = "";
    return;
  }

  const contentHeight = headerContent.offsetHeight + 160;
  const headerHeight = defaultHeaderHeight.offsetHeight;

  let viewHeightValue = "80vh";
  if (isKomitea) viewHeightValue = "60vh";

  const viewPortToCheck = viewportToPixels(viewHeightValue);

  if (contentHeight > headerHeight && contentHeight > viewPortToCheck) {
    defaultHeaderHeight.style.height = `${contentHeight}px`;
  }
  if (contentHeight <= viewPortToCheck) {
    defaultHeaderHeight.style.height = viewHeightValue;
  }
}

window.addEventListener("DOMContentLoaded", () => {
  calculateHeaderHeight();
  window.addEventListener("resize", calculateHeaderHeight);
});
